//import helpers functions
import './modules/helpers';
import './modules/script';

//import animation functions
import './modules/animations/animations';
import './modules/animations/inview';
import './modules/animations/scroll-parallax';

//import map functions
import './modules/map/map';
import './modules/map/mapalex';

//import menu functions
import './modules/menu/menu';

//import sliders functions
import './modules/sliders/HeroSlider';
